import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { NAV_ACTIONS, scrollToSection } from '../../lib/navHelpers';

const Navigation = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [active, setActive] = useState('HOME');

  useEffect(() => {
    if (location.pathname === '/') setActive('HOME');
    else if (location.pathname.startsWith('/graphic-design')) setActive('GRAPHIC DESIGN');
    else if (location.pathname.startsWith('/ui-ux')) setActive('UI / UX');
    else if (location.pathname.startsWith('/ai-creative')) setActive('AI CREATIVE');
    else if (location.pathname.startsWith('/contact')) setActive('CONTACT');
  }, [location.pathname]);

  const handleClick = (item) => {
    const action = NAV_ACTIONS[item];
    if (!action) return;

    setActive(item);

    if (action.type === 'route') {
      navigate(action.target);
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }

    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: action.target } });
    } else {
      scrollToSection(action.target);
    }
  };

  return (
    <nav className="border-b-2 divider-line">
      <ul className="flex flex-wrap items-center justify-center sm:justify-between gap-x-5 gap-y-3 py-4 px-1">
        {items.map((item) => (
          <li key={item}>
            <button
              onClick={() => handleClick(item)}
              className={`text-[9px] sm:text-[11px] tracking-[0.15em] sm:tracking-[0.22em] font-sans-ui font-medium nav-link link-underline whitespace-nowrap ${
                active === item ? 'text-[#8b2331]' : 'text-[#1a1a1a]'
              }`}
            >
              {item}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
